import { render } from "./ShgList.vue?vue&type=template&id=8fd6e2f2&scoped=true"
import script from "./ShgList.vue?vue&type=script&lang=js"
export * from "./ShgList.vue?vue&type=script&lang=js"

import "./ShgList.vue?vue&type=style&index=0&id=8fd6e2f2&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3194113096/src/coop-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fd6e2f2"]])

export default __exports__